<template>
    <div class="play-guide-wrapper">
        <transition name="navslide">
            <nav class="top-nav no-scrollbar"
                v-show="isNavShow">
                <template v-for="(item, index) in detailData">
                    <div class="each-nav"
                        :key="index"
                        :class="{active:currentIndex == index}"
                        @click.stop="linkTo(index,$event)">{{item.name}}</div>
                </template>

                <div class="slider"
                    :style="{left:currentLeft}"></div>
            </nav>
        </transition>

        <div class="guide-content">
            <div class="each-content"
                v-for="(item, index) in detailData"
                :key="index">
                <div class="anchor"></div>
                <div class="title"><span class="num">0{{index+1}}<span class="divider">/</span></span><span v-text="item.name"></span></div>
                <div class="content rich-context-wra protect-image"
                    v-html="item.content">
                </div>
                <div class="buy-btn"
                    v-if="item.name === '景点介绍'"
                    @click="$router.go(-1)">去购票
                    <!-- <span class="right-arrow"></span> -->
                    </div>
                <div class="buy-btn"
                    v-if="item.name === '周边住宿'"
                    @click="$router.push('/hotel')">去购买
                    <!-- <span class="right-arrow"></span> -->
                    </div>
                <div class="buy-btn"
                    v-if="item.name === '特色商品'"
                    @click="$router.push('/goods')">去购买
                    <!-- <span class="right-arrow"></span> -->
                    </div>
                <div class="buy-btn"
                    v-if="item.name === '文创精品'"
                    @click="$router.push('/wenchuang')">去购买
                    <!-- <span class="right-arrow"></span> -->
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
// traffic  交通指南
// introduction  景点介绍
// hotel  周边住宿
// goods  特色商品
// foods  特色美食
// description  景区概况
let t_scroll_handler;
export default {
    name: "ScenePlayGuide",
    components: {},
    props: {},
    data() {
        return {
            currentIndex: 0,
            detailData: [],
            isNavShow: true,
            scrollHandler: () => {}
        };
    },
    computed: {
        currentLeft() {
            return 0.35 + this.currentIndex * 2.5 + "rem";
        }
    },
    watch: {},
    created() {
        this.getSceneDetailData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        linkTo(index, event) {
            this.currentIndex = index;
            event.target.scrollIntoView({ behavior: "smooth" });
            setTimeout(
                () =>
                    document.querySelectorAll(".anchor")[index].scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    }),
                200
            );
        },
        getSceneDetailData() {
            this.$axios
                .get(window.API.scene.detail + `/${this.$route.params.sceneId}`)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let dArr = [];
                        let d = data.data;
                        if (d.description)
                            dArr.push({
                                name: "景区概况",
                                content: d.description
                            });
                        if (d.traffic)
                            dArr.push({
                                name: "交通指南",
                                content: d.traffic
                            });
                        if (d.introduction)
                            dArr.push({
                                name: "景点介绍",
                                content: d.introduction
                            });
                        // if (d.hotel)
                        //     dArr.push({
                        //         name: "周边住宿",
                        //         content: d.hotel
                        //     });
                        // if (d.goods)
                        //     dArr.push({
                        //         name: "特色商品",
                        //         content: d.goods
                        //     });
                        // if (d.wenchuang)
                        //     dArr.push({
                        //         name: "文创精品",
                        //         content: d.wenchuang
                        //     });
                        this.detailData = dArr;
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>

<style scoped lang="scss">
.play-guide-wrapper {
    .navslide-enter-active,
    .navslide-leave-active {
        transition: all 0.2s ease-in-out;
    }

    .navslide-enter,
    .navslide-leave-to {
        // opacity: 0;
        transform: translateY(-1.333333rem);
        will-change: transform;
    }
    .top-nav {
        display: flex;
        border-bottom: 1px solid #ebebeb;
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: $white;
        overflow-x: auto;
        z-index: 100;
        .each-nav {
            text-align: center;
            line-height: 1.333333rem;
            width: 25%;
            height: 1.333333rem;
            font-size: 15px;
            color: #999;
            transition: 0.2s;
            flex-wrap: nowrap;
            flex: none;
            &.active {
                color: $black;
                font-weight: bold;
                position: relative;
            }
        }
        .slider {
            width: 1.84rem;
            height: 0.08rem;
            position: absolute;
            bottom: 0;
            left: 0.35rem;
            transition: 0.2s ease-in-out;
            background: rgba(240, 187, 27, 1);
            box-shadow: 0px 0px 8px 0px rgba(241, 188, 0, 0.6);
        }
    }
    .guide-content {
        padding-left: 0.4rem;
        padding-right: 0.533333rem;
        margin-top: 1.333333rem;
        -webkit-overflow-scrolling: touch;
        overflow: auto;
        .each-content {
            padding: 0.8rem 0 0.4rem;
            border-bottom: 1px solid #ebebeb;
            display: flex;
            flex-direction: column;
            position: relative;
            .anchor {
                width: 0;
                height: 0;
                position: absolute;
                left: 0;
                top: -35px;
            }
            .title {
                font-size: 17px;
                color: #333;
                margin-bottom: 0.533333rem;

                span {
                    font-weight: bold;
                }
                .num {
                    font-size: 13px;
                }
                .divider {
                    font-size: 10px;
                    padding: 0 1px;
                }
            }
            .buy-btn {
                width: 2.346667rem;;
                // padding-left: 0.373333rem;
                height: 0.853333rem;
                border-radius: 0.426667rem;
                line-height: 0.773333rem;
                background: linear-gradient(
                    90deg,
                    rgba(248, 199, 64, 1) 0%,
                    rgba(245, 149, 38, 1) 100%
                );
                font-weight: bold;
                font-size: 16px;
                color: $white;
                align-self: flex-end;
                margin-top: 0.533333rem;
                display: flex;
                justify-content: center;
                align-items: center;
                .right-arrow{
                    display: inline-block;
                    height: 0.186667rem; 
                    border-style: solid;
                    border-width: 0.186667rem 0.186667rem 0.186667rem 0.186667rem;
                    border-color: transparent transparent transparent $white;
                    width: 0.186667rem;
                }
            }
            .content {
                line-height: 1.8;
            }
             .content /deep/ p {
                font-size: 14px;
                word-wrap:break-word;
            }
        }
    }
}
</style>
